import { validateCPF, validateCNPJ, validateEmail } from './helpers';

export const documentRule = () => ({
    validator(rule, value, callback) {
        value = value.replace(/\D/g, '');
        if (!value) {
            return callback();
        }
        if (value.length === 11 && validateCPF(value)) {
            return callback();
        }
        if (value.length === 14 && validateCNPJ(value)) {
            return callback();
        }
        callback(new Error('Informe um documento válido.'));
    },
});

export const emailRule = () => ({
    validator(rule, value, callback) {
        if (!value || validateEmail(value)) {
            return callback();
        }
        callback(new Error('Informe um email válido.'));
    },
});
